import { PlayerDevice } from "@/types/device"
import { PlayerData } from "@/types/player"

export function sortPlayers(a: PlayerDevice, b: PlayerDevice) {
  if (a.deviceNumber && !b.deviceNumber) {
    return -1
  } else if (!a.deviceNumber && b.deviceNumber) {
    return 1
  }

  return a.backNumber ? a.backNumber - b.backNumber : 1
}

export function playerRpeListSort(a: PlayerData, b: PlayerData) {
  if (a.playerNumber && !b.playerNumber) {
    return -1
  } else if (!a.playerNumber && b.playerNumber) {
    return 1
  }

  return a.playerNumber < b.playerNumber ? -1 : 1
}
